<template>
  <div class="login-page">
    <!-- 背景装饰 -->
    <div class="background-decoration">
      <div class="decoration-circle circle-1"></div>
      <div class="decoration-circle circle-2"></div>
      <div class="decoration-circle circle-3"></div>
    </div>

    <div class="login-container">
      <!-- 左侧欢迎信息 -->
      <div class="welcome-section">
        <div class="welcome-content">
          <div class="welcome-icon">🌴</div>
          <h1>欢迎回来</h1>
          <p>探索世界之美，从登录开始</p>
          <div class="features-list">
            <div class="feature-item">
              <span class="feature-icon">✈️</span>
              <span>专业旅游资讯</span>
            </div>
            <div class="feature-item">
              <span class="feature-icon">🏨</span>
              <span>独家旅行攻略</span>
            </div>
            <div class="feature-item">
              <span class="feature-icon">📸</span>
              <span>精美旅行图库</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧登录注册表单 -->
      <div class="form-section">
        <div class="form-container">
          <!-- 选项卡切换 -->
          <div class="tab-switcher">
            <div 
              class="tab-item" 
              :class="{ active: isLogin }"
              @click="switchToLogin"
            >
              <span class="tab-icon">🔐</span>
              用户登录
            </div>
            <div 
              class="tab-item" 
              :class="{ active: !isLogin }"
              @click="switchToRegister"
            >
              <span class="tab-icon">📝</span>
              用户注册
            </div>
          </div>

          <!-- 登录表单 -->
          <form class="login-form" v-show="isLogin" @submit.prevent="logo">
            <div class="form-group">
              <div class="input-wrapper">
                <span class="input-icon">👤</span>
                <input
                  type="text"
                  placeholder="请输入用户名"
                  id="user_name"
                  v-model="lUsername"
                  class="form-input"
                />
              </div>
            </div>
            
            <div class="form-group">
              <div class="input-wrapper">
                <span class="input-icon">🔒</span>
                <input
                  type="password"
                  placeholder="请输入密码"
                  id="password"
                  v-model="lPassword"
                  class="form-input"
                />
              </div>
            </div>

            <button type="submit" class="submit-btn">
              <span class="btn-icon">🚀</span>
              立即登录
            </button>

            <div class="form-footer">
              <p class="switch-text">
                还没有账户？
                <a href="javascript:;" @click="switchToRegister" class="switch-link">立即注册</a>
              </p>
            </div>
          </form>

          <!-- 注册表单 -->
          <form class="register-form" v-show="!isLogin" @submit.prevent="register">
            <div class="form-group">
              <div class="input-wrapper">
                <span class="input-icon">👤</span>
                <input
                  type="text"
                  placeholder="设置用户名"
                  id="r_user_name"
                  v-model="rUsername"
                  class="form-input"
                />
              </div>
            </div>
            
            <div class="form-group">
              <div class="input-wrapper">
                <span class="input-icon">🔒</span>
                <input
                  type="password"
                  placeholder="设置登录密码"
                  id="r_password"
                  v-model="rPassword"
                  class="form-input"
                />
              </div>
            </div>

            <div class="agreement-check">
              <label class="checkbox-label">
                <input type="checkbox" class="checkbox-input" />
                <span class="checkmark"></span>
                我已阅读并同意
                <a href="javascript:;" @click="Xy" class="agreement-link">《用户服务协议》</a>
              </label>
            </div>

            <button type="submit" class="submit-btn">
              <span class="btn-icon">🌟</span>
              创建账户
            </button>

            <div class="form-footer">
              <p class="switch-text">
                已有账户？
                <a href="javascript:;" @click="switchToLogin" class="switch-link">立即登录</a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLogin: true,
      href: "index.html",
      lUsername: "",
      lPassword: "",
      k: this.$route.query.k,
      logo_user: JSON.parse(window.localStorage.getItem("user")),
      rUsername: "",
      rPassword: "",
    };
  },
  components: {},
  mounted() {
    document.title = "北京邑维智能科技有限公司";
  },
  methods: {
    switchToLogin() {
      this.isLogin = true;
    },
    switchToRegister() {
      this.isLogin = false;
    },
    // 登录逻辑
    logo() {
      if (this.k) {
        window.localStorage.setItem("state", "0");
        this.$router.push("/");
      } else if (this.lUsername !== this.logo_user.Username) {
        alert("用户名错误");
      } else if (this.lPassword !== this.logo_user.Password) {
        alert("密码错误");
      } else {
        window.localStorage.setItem("state", "0");
        this.$router.push("/");
        window.location.reload();
      }
    },
    // 注册逻辑
    register() {
      // 获取 user
      var ruser = {
        Username: this.rUsername,
        Password: this.rPassword,
      };
      // 判断非空
      if (!this.rUsername) {
        alert("请输入用户名");
        return;
      }
      if (!this.rPassword) {
        alert("请输入密码");
        return;
      }
      window.localStorage.setItem("state", "0");
      window.localStorage.setItem("user", JSON.stringify(ruser));
      this.$router.push("/");
      window.location.reload();
    },
    // 跳转协议
    Xy() {
      this.$router.push("/xy");
    },
  },
};
</script>

<style lang="scss" scoped>
// 使用方案2的颜色变量
$primary-color: #d4b896;
$primary-dark: #bfa07d;
$primary-light: #e9d4b8;
$accent-color: #5a8fb4;
$text-dark: #2c3e50;
$text-light: #7f8c8d;
$background: #f9f7f2;
$card-bg: #ffffff;

.login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, $background 0%, #f0ebe0 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  font-family: "Helvetica Neue", Arial, "PingFang SC", "Microsoft YaHei", sans-serif;
  position: relative;
  overflow: hidden;

  .background-decoration {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;

    .decoration-circle {
      position: absolute;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(212, 184, 150, 0.1) 0%, rgba(90, 143, 180, 0.05) 100%);
    }

    .circle-1 {
      width: 300px;
      height: 300px;
      top: -100px;
      left: -100px;
    }

    .circle-2 {
      width: 200px;
      height: 200px;
      bottom: -50px;
      right: 10%;
    }

    .circle-3 {
      width: 150px;
      height: 150px;
      top: 20%;
      right: -50px;
    }
  }

  .login-container {
    display: flex;
    width: 100%;
    max-width: 1000px;
    background: $card-bg;
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    position: relative;
    z-index: 1;

    // 左侧欢迎区域
    .welcome-section {
      flex: 1;
      background: linear-gradient(135deg, $primary-color 0%, $primary-dark 100%);
      color: white;
      padding: 60px 40px;
      display: flex;
      align-items: center;
      justify-content: center;

      .welcome-content {
        text-align: center;
        max-width: 400px;

        .welcome-icon {
          font-size: 80px;
          margin-bottom: 20px;
          display: block;
        }

        h1 {
          font-size: 32px;
          font-weight: 700;
          margin-bottom: 15px;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
        }

        p {
          font-size: 16px;
          opacity: 0.9;
          margin-bottom: 40px;
          line-height: 1.6;
        }

        .features-list {
          .feature-item {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            margin-bottom: 15px;
            font-size: 16px;
            opacity: 0.9;

            .feature-icon {
              font-size: 20px;
            }
          }
        }
      }
    }

    // 右侧表单区域
    .form-section {
      flex: 1;
      padding: 60px 50px;
      display: flex;
      align-items: center;
      justify-content: center;

      .form-container {
        width: 100%;
        max-width: 380px;

        .tab-switcher {
          display: flex;
          background: rgba(212, 184, 150, 0.1);
          border-radius: 30px;
          padding: 6px;
          margin-bottom: 40px;

          .tab-item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
            padding: 12px 20px;
            border-radius: 25px;
            cursor: pointer;
            transition: all 0.3s ease;
            font-weight: 600;
            color: $text-dark;

            .tab-icon {
              font-size: 18px;
            }

            &.active {
              background: $primary-color;
              color: white;
              box-shadow: 0 4px 12px rgba(212, 184, 150, 0.3);
            }

            &:hover:not(.active) {
              background: rgba(212, 184, 150, 0.2);
            }
          }
        }

        .form-group {
          margin-bottom: 25px;

          .input-wrapper {
            position: relative;
            display: flex;
            align-items: center;

            .input-icon {
              position: absolute;
              left: 18px;
              font-size: 18px;
              color: $text-light;
              z-index: 2;
            }

            .form-input {
              width: 100%;
              height: 56px;
              padding: 0 20px 0 50px;
              border: 2px solid rgba(212, 184, 150, 0.2);
              border-radius: 12px;
              font-size: 16px;
              transition: all 0.3s ease;
              background: #fafafa;

              &:focus {
                outline: none;
                border-color: $primary-color;
                background: $card-bg;
                box-shadow: 0 0 0 3px rgba(212, 184, 150, 0.1);
              }

              &::placeholder {
                color: #aaa;
              }
            }
          }
        }

        .agreement-check {
          margin: 25px 0;

          .checkbox-label {
            display: flex;
            align-items: center;
            cursor: pointer;
            font-size: 14px;
            color: $text-light;

            .checkbox-input {
              display: none;

              &:checked + .checkmark {
                background: $primary-color;
                border-color: $primary-color;

                &::after {
                  display: block;
                }
              }
            }

            .checkmark {
              width: 18px;
              height: 18px;
              border: 2px solid #ddd;
              border-radius: 4px;
              margin-right: 10px;
              position: relative;
              transition: all 0.3s ease;

              &::after {
                content: '';
                position: absolute;
                left: 4px;
                top: 1px;
                width: 6px;
                height: 10px;
                border: solid white;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
                display: none;
              }
            }

            .agreement-link {
              color: $primary-color;
              text-decoration: none;
              margin-left: 4px;

              &:hover {
                text-decoration: underline;
              }
            }
          }
        }

        .submit-btn {
          width: 100%;
          height: 56px;
          background: linear-gradient(135deg, $primary-color, $primary-dark);
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          box-shadow: 0 4px 15px rgba(212, 184, 150, 0.3);

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(212, 184, 150, 0.4);
            background: linear-gradient(135deg, $primary-dark, $primary-color);
          }

          .btn-icon {
            font-size: 18px;
          }
        }

        .form-footer {
          margin-top: 30px;
          text-align: center;

          .switch-text {
            font-size: 14px;
            color: $text-light;

            .switch-link {
              color: $primary-color;
              text-decoration: none;
              font-weight: 600;

              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }
}

// 响应式调整
@media (max-width: 768px) {
  .login-page {
    padding: 20px 15px;

    .login-container {
      flex-direction: column;
      border-radius: 16px;

      .welcome-section {
        padding: 40px 30px;

        .welcome-content {
          h1 {
            font-size: 26px;
          }

          p {
            font-size: 14px;
          }

          .features-list .feature-item {
            font-size: 14px;
          }
        }
      }

      .form-section {
        padding: 40px 30px;
      }
    }
  }
}

@media (max-width: 480px) {
  .login-page .login-container {
    .welcome-section {
      padding: 30px 20px;

      .welcome-content {
        .welcome-icon {
          font-size: 60px;
        }

        h1 {
          font-size: 22px;
        }

        .features-list .feature-item {
          font-size: 13px;
        }
      }
    }

    .form-section {
      padding: 30px 20px;
    }
  }
}
</style>